(() => {
  if (window.ksBlogPaginationReady) return;
  window.ksBlogPaginationReady = true;
  const states = new WeakMap();
  const init = (section) => {
    if (states.has(section)) return states.get(section);
    const grid = section.querySelector('[data-list-grid]');
    if (!grid) return null;
    const pending = [...grid.querySelectorAll('[data-blog-overflow]')];
    pending.forEach((item) => item.remove());
    const state = { grid, pending, next: section.dataset.blogNext, busy: false };
    states.set(section, state);
    update(section, state);
    return state;
  };
  const update = (section, state) => {
    const count = state.grid.querySelectorAll('[data-list-key]:not(.blog-section__article--featured)').length;
    const label = section.querySelector('[data-blog-count]');
    if (label) label.textContent = `${count} articles shown`;
    const link = section.querySelector('[data-blog-load-more]');
    if (link) {
      link.hidden = !state.next && !state.pending.length;
      if (state.next) link.href = state.next;
    }
  };
  const scan = () => document.querySelectorAll('[data-blog-pagination]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('click', async (event) => {
    const link = event.target instanceof Element && event.target.closest('[data-blog-load-more]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = link.closest('[data-blog-pagination]');
    const state = section && init(section);
    if (!state) return;
    event.preventDefault();
    if (state.busy) return;
    state.busy = true;
    state.grid.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Loading…';
    const status = section.querySelector('[data-list-status]');
    try {
      // Keep leftovers and the source cursor together, including on failed retries.
      const visited = new Set();
      while (state.pending.length < 18 && state.next) {
        if (visited.has(state.next)) throw new Error('Repeated blog page');
        visited.add(state.next);
        const url = new URL(state.next, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid blog page');
        url.searchParams.set('section_id', section.dataset.listSection);
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Unable to load blog');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = [...parsed.querySelectorAll('[data-blog-pagination]')].find((el) => el.dataset.listSection === section.dataset.listSection);
        if (!next?.querySelector('[data-list-grid]')) throw new Error('Missing blog results');
        if (!section.isConnected) return;
        const seen = new Set([...state.grid.querySelectorAll('[data-list-key]'), ...state.pending].map((item) => item.dataset.listKey));
        next.querySelectorAll('[data-list-grid] > [data-list-key]').forEach((item) => {
          if (seen.has(item.dataset.listKey)) return;
          seen.add(item.dataset.listKey);
          item.hidden = false;
          item.removeAttribute('data-blog-overflow');
          item.classList.remove('blog-section__article--featured');
          state.pending.push(item);
        });
        state.next = next.dataset.blogNext;
      }
      const added = state.pending.splice(0, 18);
      const fragment = document.createDocumentFragment();
      added.forEach((item) => { item.hidden = false; item.removeAttribute('data-blog-overflow'); fragment.append(item); });
      state.grid.append(fragment);
      added.forEach((item) => window.KSTheme?.init?.(item));
      update(section, state);
      if (added[0]) { added[0].tabIndex = -1; added[0].focus({ preventScroll: true }); }
      if (status) status.textContent = `${added.length} more articles loaded.`;
    } catch (error) {
      if (status) status.textContent = 'Could not load more articles. Please try again.';
    } finally {
      state.busy = false;
      state.grid.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      link.textContent = 'Load more';
    }
  });
})();
